import React from "react"

import { Spin, Space } from "antd"

const Loading = () => {
  return (
    <Space direction="horizontal" style={{ width: "100%", justifyContent: "center", padding: 10 }} size="middle">
      <Spin size="large" tip="Yükleniyor..." />
    </Space>
  )
}

export default Loading
